<div class="chat-admin admin-page ct-page">
  <header class="page-head">
    <div>
      <p>{{ 'chat.admin.subtitle' | t }}</p>
    </div>
    <div class="head-actions">
      <button type="button" class="mute" (click)="toggleMute()">
        {{ mute() ? ('chat.unmute' | t) : ('chat.mute' | t) }}
      </button>
    </div>
  </header>

  @if (error(); as err) {
    <p class="error">{{ err }}</p>
  }

  <div class="layout">
    <aside class="list">
      <div class="list-body">
        @if (loading()) {
          <p class="muted pad">{{ 'common.loading' | t }}</p>
        } @else if (conversations().length === 0) {
          <p class="muted pad">{{ 'chat.admin.empty' | t }}</p>
        } @else {
          @for (c of conversations(); track c.id) {
            <a
              class="row"
              [routerLink]="['/admin/chat', c.id]"
              [class.active]="selected()?.id === c.id"
            >
              <div class="row-main">
                <p>
                  <time>{{ c.lastMessageAt | date: 'shortTime' }}</time>
                  <span class="sep">·</span>
                  <span class="preview">{{ c.lastMessagePreview || ('chat.admin.noPreview' | t) }}</span>
                </p>
                @if (c.unreadCount > 0) {
                  <span class="badge">{{ c.unreadCount }}</span>
                }
              </div>
            </a>
          }
        }
      </div>
    </aside>

    <section class="thread">
      @if (selected(); as detail) {
        <div class="messages" #messagesPane>
          @for (m of detail.messages; track m.id) {
            <div class="bubble" [class.visitor]="m.senderType === 'Visitor'" [class.admin]="m.senderType === 'Admin'">
              <p>{{ m.body }}</p>
              <small>{{ m.createdAt | date: 'short' }} · {{ m.senderType }}</small>
            </div>
          }
        </div>
        <form class="composer" (submit)="$event.preventDefault(); send()">
          <input
            type="text"
            [ngModel]="draft()"
            (ngModelChange)="draft.set($event)"
            name="adminDraft"
            [placeholder]="'chat.admin.placeholder' | t"
            maxlength="4000"
          />
          <button type="submit" [disabled]="sending() || !draft().trim()">{{ 'chat.send' | t }}</button>
        </form>
      } @else {
        <div class="placeholder">
          <p>{{ 'chat.admin.pick' | t }}</p>
        </div>
      }
    </section>
  </div>
</div>
